import { array, arrayOf, bool, func, number, object, oneOf, oneOfType, shape, string } from 'prop-types'
import { NORMAL_USER_TYPES, SPECIAL_USER_TYPES } from 'common/constants'
import * as modalTypes from 'components/Modal/modalTypes'

/* ----- Basic Shapes ----- */

const userShortShape = shape({
  age: number,
  city: string,
  country: string,
  screenName: string,
  online: bool,
  imageAmount: number,
})

const colors = oneOf(['main', 'highlight', 'cta'])

/* ----- Avatar ----- */

export const avatarType = {
  inverted: bool,
  size: oneOf(['compact', 'thumbnail', 'large', 'responsive']),
  source: oneOf(['user', 'notifications', 'flirt']),
  url: string,
  user: object,
  filter: number,
}

/* ----- Button ----- */

export const buttonType = {
  to: string,
  onClick: func,
  color: colors,
  label: string,
  icon: string,
  disabled: bool,
  fill: oneOf(['filled', 'link', 'transparent']),
  size: oneOf(['base', 'small', 'medium', 'large']),
  type: oneOf(['button', 'submit', 'reset']),
}

/* ----- Icon ----- */

export const iconType = {
  family: string,
  name: string,
  src: string,
  svg: bool,
}

/* ----- UserList  ----- */

const combinationIndexes = new Array(Math.pow(2, NORMAL_USER_TYPES.length)).fill().map((_, i) => i)
const options = combinationIndexes.map(i => NORMAL_USER_TYPES.filter((_, j) => i & Math.pow(2, j)).join(','))

export const userListType = {
  header: oneOfType([string, func]),
  inverted: bool,
  limit: number,
  placeholders: number,
  users: arrayOf(userShortShape),
  filter: oneOf(options.concat(SPECIAL_USER_TYPES, 'flirts', 'myFlirts', 'withMe', 'mutual')),
}
/* ----- UserThumb ----- */

export const userThumbType = {
  inverted: bool,
  user: userShortShape,
}

/* ----- Checkbox ----- */

export const checkboxType = {
  defaultChecked: bool,
  checked: bool,
  name: oneOfType([string, number]).isRequired,
  onChange: func,
  required: bool,
  text: oneOfType([string, object]),
  value: bool,
}

/* ----- Radio ----- */

export const radioType = {
  checked: bool,
  required: bool,
  name: string,
  onChange: func,
  value: oneOfType([string, number]).isRequired,
  label: string,
}

/* ----- RadioGroup ----- */

export const radioGroupType = {
  required: bool,
  defaultChecked: string.isRequired,
  layout: oneOf(['horizontal', 'vertical']),
  name: string.isRequired,
}

/* ----- Select ----- */

export const selectType = {
  name: string,
  onChange: func,
  options: array,
  required: bool,
  values: array,
}

/* ----- TextArea ----- */

export const textAreaType = {
  name: string.isRequired,
  onChange: func,
  placeholder: string,
  required: bool,
  spellCheck: bool,
}

/* ----- Membership ----- */

export const membershipType = {
  duration: oneOfType([number, string]),
  type: string,
  price: shape({
    currency: string,
    value: oneOfType([number, string]),
    period: string,
  }),
  discount: number,
  name: string,
}

/* ----- Modals -----*/

export const modalType = {
  onClose: func,
  transparentBackground: bool,
  contentProps: object,
  close: shape({
    escape: bool,
    overlay: bool,
    button: bool,
    disabled: bool,
    timeout: number,
  }),
  modalId: oneOf(Object.values(modalTypes)),
}

export const galleryModalType = {
  images: arrayOf(object),
  isMyProfile: bool,
}

/* ----- Translations ----- */

export const translationType = {
  fallback: string,
  variables: object,
  components: object,
}
